import { simpleSet } from '@r/reducers/utils';

const setCalculationModeLegsValue = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.materials.legs.value;

export const value = setCalculationModeLegsValue(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_LEGS_VALUE',
  { value: '', label: '' }
);
